import { FormControlLabel, Switch } from '@mui/material';
import { FC } from 'react';

type Props = {
  checked: boolean;
  onChange: () => void;
};

const NotifyMailroomSwitch: FC<Props> = ({ checked, onChange }) => (
  <FormControlLabel
    control={<Switch />}
    sx={{ mt: 3 }}
    checked={checked}
    onChange={onChange}
    label="Notify Mailroom and Recipient"
  />
);

export default NotifyMailroomSwitch;
